import '@angular/compiler';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PageMainComponent } from './page.main/page.main.component';
import { ComponentChecktopComponent } from './component.checktop/component.checktop.component';
import { ComponentCheckrightComponent } from './component.checkright/component.checkright.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { ComponentQnatopComponent } from './component.qnatop/component.qnatop.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageCheckComponent } from './page.check/page.check.component';
import { ComponentChecknoneComponent } from './component.checknone/component.checknone.component';
import { ComponentQnalistComponent } from './component.qnalist/component.qnalist.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { ComponentCheckhistoryComponent } from './component.checkhistory/component.checkhistory.component';
import { ComponentQnacreateComponent } from './component.qnacreate/component.qnacreate.component';
import { ComponentQnaautoComponent } from './component.qnaauto/component.qnaauto.component';
import { ComponentChecklistComponent } from './component.checklist/component.checklist.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { ComponentCheckallComponent } from './component.checkall/component.checkall.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        AppComponent,
        PortalSeasonStatusbarComponent,
        PortalSeasonTabComponent,
        PageMainComponent,
        ComponentChecktopComponent,
        ComponentCheckrightComponent,
        PortalSeasonAlertComponent,
        ComponentQnatopComponent,
        PortalSeasonLoadingSeasonComponent,
        PageCheckComponent,
        ComponentChecknoneComponent,
        ComponentQnalistComponent,
        PortalSeasonLoadingComponent,
        PortalSeasonPagenationComponent,
        LayoutNavbarComponent,
        PortalSeasonViewerTreeComponent,
        ComponentCheckhistoryComponent,
        ComponentQnacreateComponent,
        ComponentQnaautoComponent,
        ComponentChecklistComponent,
        PortalSeasonUiDropdownComponent,
        PortalSeasonLoadingHexaComponent,
        ComponentCheckallComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }